<template>
  <v-card width="auto" tile>
    <v-form ref="form">
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-layout justify-end>
          <v-btn class="red darken-1 mr-3" dark @click="onCancel">Cerrar</v-btn>
        </v-layout>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
export default {
  name: 'ViewConceptsNomina',
  mixins: [],
  props: ['model', 'onCancel'],
  data: () => ({
    table: {
      header: {
        options: [],
        titles: [
          { text: 'Concepto', value: 'concepto.nombre', class: 'black--text' },
          { text: 'Tipo', value: 'tipo_operacion', class: 'black--text' },
          { text: 'Importe', value: 'FieldDinamicData', class: 'black--text', action: 'FormatNumberMoney', field: 'importe' },
          { text: '', value: 'log.concepto_nombre', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    }
  }),
  components: {
    DataTableMain
  },
  mounted () {
    if (this.model.detalles_nominas) {
      this.model.detalles_nominas.map(detalle => {
        if (detalle.concepto.formula.cambiar_nombre) {
          detalle.concepto.nombre += ' ' + this.model.adscripcion.plaza.tipo_plaza.nombre
        }
      })
      this.table.body.data = this.model.detalles_nominas
    }
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    tableAction (item) {
      this[item.action](item)
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain'])
  }

}
</script>

<style>

</style>
